var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "success-alert"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M90 45.0011C90 69.8558 69.8544 90.0007 45.0007 90C20.1456 90.0007 5.63602e-08 69.8558 5.63602e-08 45.0011C-0.00123041 20.1463 20.1456 0 45.0007 0C69.8544 0 90 20.147 90 45.0011Z",
    fill: "#2BA62C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M89.9499 46.9992C89.929 46.9751 89.9081 46.951 89.8852 46.9285C89.846 46.8897 66.5568 23.5997 66.5075 23.551C66.4685 23.5123 66.4249 23.4802 66.3857 23.4418C66.3363 23.3923 66.2947 23.3374 66.2449 23.2882C60.5725 17.6748 52.988 14.6466 44.9787 14.8036C36.8873 14.9426 29.2728 18.2115 23.5389 24.0077C17.7666 29.8424 14.6645 37.4845 14.8036 45.5259C14.944 53.6159 18.1236 61.1401 23.7568 66.7125C23.7966 66.7517 23.8407 66.7846 23.8804 66.8234C23.9289 66.8721 23.9704 66.9266 24.0194 66.9751C24.0592 67.0143 46.9556 89.8995 46.9953 89.9385C46.9988 89.942 47.0018 89.9461 47.0055 89.9496C70.2654 88.93 88.9328 70.2607 89.9499 46.9992Z",
    fill: "#1E931F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M45.2036 75.2078C28.5915 75.2078 15 61.6161 15 45.0042C15 28.3923 28.5915 14.8007 45.2036 14.8007C61.8156 14.8007 75.407 28.3923 75.407 45.0042C75.407 61.6161 61.8155 75.2078 45.2036 75.2078ZM45.2036 17.124C29.8694 17.124 17.3234 29.6701 17.3234 45.0042C17.3234 60.3384 29.8694 72.8844 45.2036 72.8844C60.5377 72.8844 73.0837 60.3384 73.0837 45.0042C73.0837 29.6701 60.5376 17.124 45.2036 17.124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M41.7182 55.4591C41.4859 55.4591 41.2534 55.3429 41.0211 55.2268L29.4044 45.9333C28.9397 45.5849 28.8235 44.7717 29.1721 44.307C29.5207 43.8423 30.3337 43.7261 30.7984 44.0747L41.602 52.6711L59.4918 32.5741C59.9565 32.1094 60.6534 31.9932 61.1181 32.458C61.5829 32.9227 61.699 33.6196 61.2343 34.0843L42.6475 54.9945C42.4152 55.3429 42.0667 55.4591 41.7182 55.4591Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessAlert);
export default __webpack_public_path__ + "static/media/success-alert.ca0ce5f178a8f3f6af3e08ae9b7e8183.svg";
export { ForwardRef as ReactComponent };